import { PersonAttributes, useEstatePeople } from './estate-people'

/** Taking a role away leaves the person on the estate. */
export type Role = {
  memberIds: number[]
  add: (personId: number) => Promise<unknown>
  remove: (personId: number) => Promise<unknown>
  // one save, so a role kept as a list (a property's co-owners) doesn't
  // lose one change to the other
  replace: (fromId: number, toId: number) => Promise<unknown>
  addNew: (attributes: PersonAttributes) => Promise<number>
}

export const useAttributesRole = ({
  isMember,
  given,
  taken,
}: {
  isMember: (attributes: PersonAttributes) => boolean
  given: PersonAttributes
  taken: PersonAttributes
}): Role => {
  const { people, createPerson, updatePerson } = useEstatePeople()

  return {
    memberIds: people
      .filter((person) => isMember(person.attributes))
      .map((person) => person.id),
    add: (personId) => updatePerson(personId, given),
    remove: (personId) => updatePerson(personId, taken),
    // the new person first, so a failure never leaves the role with nobody
    replace: async (fromId, toId) => {
      await updatePerson(toId, given)
      try {
        await updatePerson(fromId, taken)
      } catch (error) {
        await updatePerson(toId, taken).catch(() => undefined)
        throw error
      }
    },
    addNew: async (attributes) =>
      (await createPerson({ ...attributes, ...given })).id,
  }
}
